import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import Breadcrumbs from '../components/Breadcrumbs'
import { Link } from 'react-router-dom'
import Button from '../components/Button'

const Header_1 = ({ title, description, component = "Button", pdf, buttons, sectionClass, activePage, activeInnerPage, staticDescription=false }) => {
    return (
        <section className={`no_banner ${sectionClass} pt-pb-10 sec-orange-color`}>
            <div className='page-breadcrumb pb-5'>
                {/* <Breadcrumbs /> */}

                <Breadcrumbs activePage={activePage} activeInnerPage={activeInnerPage} buttonText={title} sectionClass={sectionClass} />
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-4 title-col'>
                        {title && <h1 className='text-orange' lang="de">{title}</h1>}
                    </div>
                    <div className='col-lg-8 content-col fw_strong_500'>
                        {description && !staticDescription && <BlocksRenderer content={description} />}
                        {staticDescription && <p>{description}</p>}
                        {/* <p>Als innovative Genossenschaft ist die Baugenossenschaft Zurlinden (BGZ) bestrebt, Siedlungen zu bauen und instand zu halten, die den Anforderungen an nachhaltigen, sicheren und energieeffizienten Wohnraum gerecht werden. Auch Sie als Mieterin oder Mieter leisten mit Ihrem Verhalten einen wichtigen Beitrag zu einem angenehmen und sicheren Wohnumfeld. Nachfolgend finden Sie einige Tipps und Hinweise für den Alltag.</p> */}

                        <Button component={component} pdf={pdf} buttons={buttons} />

                        {/* <div className='btn-container'>
                                <Link className='button round_btn round_pdf_btn btn-theme-color'>
                                    PDF-Merkblatt «Rund ums Wohnen»
                                    <span>
                                        <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.9999 26.46C11.7285 26.46 11.4571 26.36 11.2439 26.155L2.01608 17.485C1.55566 17.055 1.52658 16.32 1.94338 15.845C2.36018 15.37 3.07262 15.34 3.53304 15.77L11.9999 23.735L20.4668 15.77C20.9272 15.34 21.6348 15.375 22.0565 15.845C22.4733 16.32 22.4393 17.05 21.9838 17.485L12.756 26.16C12.5427 26.36 12.2713 26.46 11.9999 26.46Z" fill="inherit" />
                                            <path d="M11.9999 26.46C11.3796 26.46 10.8756 25.94 10.8756 25.3V1.16C10.8756 0.519999 11.3796 0 12 0C12.6203 0 13.1244 0.519999 13.1244 1.16V25.3C13.1244 25.945 12.6203 26.46 11.9999 26.46Z" fill="inherit" />
                                            <path d="M22.8756 32H1.12439C0.504039 32 0 31.48 0 30.84C0 30.2 0.504039 29.68 1.12439 29.68H22.8756C23.496 29.68 24 30.2 24 30.84C24 31.48 23.496 32 22.8756 32Z" fill="inherit" />
                                        </svg>
                                    </span>
                                </Link>
                            </div> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Header_1